import React, { forwardRef } from "react";
import FormInput from "../../../designSystem/FormInput";

const FormattedNumberInput = forwardRef(
  ({ value = "", onChange, title, className = "", ...props }, ref) => {
    const displayValue = String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    return (
      <FormInput
        {...props}
        ref={ref}
        title={title}
        className={className}
        inputMode="decimal"
        value={displayValue}
        onChange={(event) => {
          const rawValue = event.target.value
            .replace(/,/g, "")
            .replace(/[^\d.]/g, "")
            .replace(/(\..*)\./g, "$1");
          onChange?.(rawValue);
        }}
      />
    );
  },
);

FormattedNumberInput.displayName = "FormattedNumberInput";

export default FormattedNumberInput;
